import * as z from 'zod/mini'
import { EditUserBody, UserInfo, userFields } from '@seiri/shared/common'
import { requiredFormDate, requiredText } from './form-schema'

/**
 * The signed-in user's own profile. The form requires the names, phone and birth date the API
 * leaves optional, and holds the picker's `Date` - hence its own schema and `toEditUserBody`.
 */
export const profileFormModel = z.object({
  firstName: userFields.firstName.check(requiredText),
  lastName: userFields.lastName.check(requiredText),
  phone: userFields.phone.check(requiredText),
  birthDate: requiredFormDate(),
  description: userFields.description,
})
export type ProfileFormModel = z.infer<typeof profileFormModel>

export const toProfileFormModel = (user: UserInfo | null): ProfileFormModel => ({
  firstName: user?.firstName || '',
  lastName: user?.lastName || '',
  phone: user?.phone || '',
  birthDate: user?.birthDate ? new Date(user.birthDate) : null,
  description: user?.description || '',
})

export const toEditUserBody = (model: ProfileFormModel): EditUserBody => ({
  firstName: model.firstName,
  lastName: model.lastName,
  phone: model.phone,
  description: model.description,
  ...(model.birthDate && { birthDate: model.birthDate.toISOString() }),
})
